import Label from '../../../atoms/formParts/Label';
import useCustomHomeModalData from './useCustomHomeModalData';
import Switch from 'react-switch';
import CustomHomeModalImageUploader from './CustomHomeModalImageUploader';

const CustomHomeModalAdminMapFormData = ({ setFieldValue, values }) => {
  const { customModalHomeFormData, customModalHomeFormMessages, customModalHomeData } = useCustomHomeModalData();

  return (
    <div className='form-columns'>
      {customModalHomeFormData.map((data, index) => (
        <div className='form-group' key={index}>
          <Label>{data.label}</Label>
          {data.id === 'img'
            ? (
              <CustomHomeModalImageUploader
                setFieldValue={setFieldValue}
                customModalHomeFormMessages={customModalHomeFormMessages}
                values={values}
              />
            )
            : data.id === 'active'
              ? (
                <div className='form-group switch-wrapper'>
                  <label htmlFor='active' className='switch-label'>
                    {values.active
                      ? customModalHomeData.custom_home_modal_admin_form_status_label_activated
                      : customModalHomeData.custom_home_modal_admin_form_status_label_deactivated}
                  </label>
                  <Switch
                    onChange={(checked) => setFieldValue('active', checked)}
                    checked={!!values.active}
                    id='active'
                    offColor='#bbb'
                    onColor='#4F46E5'
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={22}
                    width={48}
                    handleDiameter={20}
                  />
                </div>
              )
              : (
                null
              )}
        </div>
      ))}
    </div>
  );
};

export default CustomHomeModalAdminMapFormData;
